<template>
  <view class="container">
    <!-- 渐变背景容器 -->
    <view class="gradient-background">
      <!-- 自定义导航栏 -->
      <view class="custom-nav">
        <view :style="{ height: statusbarHeight + 'px' }"></view>
        <view class="nav-content" :style="{ height: navHeight + 'px' }">
          <image class="nav-icon" src="/static/icon/ic_home@2x.png" @click="goToStore"></image>
          <text class="nav-title">{{ shopInfo.shopName || '' }}</text>
        </view>
      </view>
      <view :style="{ height: (statusbarHeight + navHeight) + 'px' }"></view>
    <!-- 功能按钮 -->
    <view class="function-buttons">
		<view class="func-btn" @click="jump(0)">
			<image class="func-icon" src="/shop/static/icon/ic_zitihexiao@2x.png"></image>
			<text class="func-text">我是用户</text>
		</view>
		<view class="func-btn" @click="jump(1)">
			<image class="func-icon" src="/shop/static/icon/ic_dingdanguanli@2x.png"></image>
			<text class="func-text">我是门店</text>
		  </view>
		</view>
	</view>
  </view>
</template>

<script>
import { mapState } from 'vuex'
export default { 
  computed: {
    ...mapState(['navHeight', 'statusbarHeight' ])
  },
  onReachBottom() {
    console.log('store-home onReachBottom')
  },
 onShow() {
 },
  methods: {
	  jump(type){
		  if(type == 0){
			  uni.switchTab({
			  	url: "/pages/index/index"
			  })
		  }else{
			  uni.switchTab({
			  	url: "/shop/pages/login/login"
			  })
		  }
	  }
  },
  data() {
    return {
      bgImg: require('@/static/image/bg_card@2x.png'),
    }
  }
};
</script>

<style lang="scss" scoped>
$bg-color: #f5f5f5;
$primary-color: #1677ff;
$danger-color: #ff4d4f;
$text-color: #333;
$text-tertiary-color: #999;

.container {
  background-color: $bg-color;
  min-height: 100vh;
}
.loading-text {
		padding: 18rpx 0 8rpx;
		text-align: center;
		font-size: 22rpx;
		color: #a5aab3;
	}
/* 渐变背景容器 */
.gradient-background {
  padding: 0 30rpx;
  box-sizing: border-box;
  width: 100%;
  background: #C8F3FF;
  color: #1a1a1a;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50%;
    background: linear-gradient(to bottom, transparent, #ffffff);
  }
}

/* 自定义导航栏 */
.custom-nav {
  width: 100%;
  color: #1a1a1a;
  background-color: #C8F3FF;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
}

.nav-content {
  display: flex;
  align-items: center;
  padding: 0 20rpx;
}

.nav-icon {
  width: 64rpx;
  height: 64rpx;
  margin-right: 14rpx;
}

.nav-title {
  font-size: 32rpx;
  font-weight: bold;
}

.stats-section {
  height: 256rpx;
  width: 100%;
  padding: 30rpx;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: 20rpx;
  position: relative;
  z-index: 99;
}

.stats-tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20rpx;
  position: relative;
  z-index: 1;
}

.stats-tabs-left {
  width: 43%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tab-item {
  font-size: 28rpx;
  color: rgba(255,255,255,0.8);

  &.active {
    font-size: 32rpx;
    color: white;
    font-weight: 600;
  }

  &.right {
    color: white;
  }
}

.stats-cards {
  width: 100%;
  height: 132rpx;
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 1;
  padding-top: 22rpx;
  box-sizing: border-box;
  border-top: 1rpx solid rgba(255,255,255,0.09);
}

.stat-card {
  flex: 1;
  text-align: left;
  &:nth-child(1) {
    flex: 2.3;
  }
  &:nth-child(2) {
    flex: 2;
  }
}

.stat-label {
  display: flex;
  height: 40rpx;
  text {
    font-size: 24rpx;
    font-weight: 400;
    color: rgba(255,255,255,0.7);
  }
  .stat-icon {
    width: 40rpx;
    height: 40rpx;
    margin-left: 10rpx;
  }
}

.stat-value {
  font-weight: 600;
  font-size: 44rpx;
  color: #FFFFFF;
  margin-top: 14rpx;
}

.function-buttons {
  background-color: white;
  margin: 30rpx 30rpx 40rpx 30rpx;
  border-radius: 16rpx;
  padding: 30rpx;
  display: flex;
  justify-content: space-between;
}

.func-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 120rpx;
}

.func-icon {
  width: 88rpx;
  height: 88rpx;
  margin-bottom: 16rpx;
}

.func-text {
  font-weight: 400;
  font-size: 26rpx;
  color: #333333;
  white-space: nowrap;
}

.orders-section {
  margin: 30rpx;
}

.section-title {
  width: 100%;
  font-weight: 600;
  font-size: 32rpx;
  color: #111111;
  padding: 0 30rpx;
  box-sizing: border-box;
}

.order-item {
  background: #FFFFFF;
  border-radius: 16rpx;
  padding: 30rpx;
  box-sizing: border-box;
  margin-bottom: 20rpx;
  &:last-child {
    margin-bottom: 0;
  }
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28rpx;
  flex-wrap: wrap;
}

.order-tag {
  background-color: #10B2FA;
  color: white;
  width: 104rpx;
  height: 40rpx;
  line-height: 40rpx;
  font-weight: 400;
  font-size: 22rpx;
  color: #FFFFFF;
  text-align: center;
  background: #10B2FA;
  border-radius: 8rpx;
  margin-right: 20rpx;
}

.order-user {
  font-weight: 400;
  font-size: 28rpx;
  color: #333333;
}

.order-status {
  font-weight: 400;
  font-size: 26rpx;
  color: #FF0020;
}

.order-product {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 26rpx;
}

.product-info {
  flex: 3;
  display: flex;
  flex-direction: column;
}

.product-name {
  font-weight: 600;
  font-size: 28rpx;
  color: #333333;
}

.product-spec {
  font-weight: 400;
  font-size: 24rpx;
  color: #8C939F;
  margin-top: 12rpx;
}

.product-price-count {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.product-price {
  font-weight: 400;
  font-size: 30rpx;
  color: #333333;
}

.product-count {
  font-weight: 400;
  font-size: 24rpx;
  color: #8C939F;
  margin-top: 12rpx;
}

.order-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30rpx 0;
}

.total-price {
  display: flex;
  align-items: center;
  text {
    &:nth-child(1) {
      font-weight: 400;
      font-size: 26rpx;
      color: #333333;
    }
    &:nth-child(2) {
      font-weight: 600;
      font-size: 26rpx;
      color: #222222;
    }
  }
}

.order-buttons {
  display: flex;
  gap: 20rpx;
}

.btn {
  width: 160rpx;
  height: 64rpx;
  line-height: 64rpx;
  text-align: center;
  border-radius: 34rpx;
  font-size: 28rpx;
  padding: 0 !important;

  &.secondary {
    background-color: white;
    color: #004096;
    border: 2rpx solid #004096;
  }

  &.primary {
    background-color: #004096;
    color: white;
  }
}

.order-note {
  width: 100%;
  font-size: 26rpx;
  color: red;
  background-color: #F8F9FB;
  padding: 20rpx;
  box-sizing: border-box;
  border-radius: 8rpx;
  margin-top: 20rpx;
}
</style>